var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox merchant-division-config" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            shadow: "never",
            bordered: false,
            "body-style": { padding: "0" },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    size: "small",
                    "label-position": "right",
                    inline: "",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户ID：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入商户ID", clearable: "" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          },
                        },
                        model: {
                          value: _vm.searchForm.merId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "merId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.merId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            shadow: "never",
            bordered: false,
            "body-style": { padding: "24px" },
          },
        },
        [
          _c("div", { staticClass: "config-header" }, [
            _c("div", [
              _c("div", { staticClass: "config-title" }, [
                _vm._v("商户分账配置"),
              ]),
              _c("div", { staticClass: "config-subtitle" }, [
                _vm._v(
                  "支持查询单商户配置并编辑接收方id，保存后会自动刷新最新绑定状态。"
                ),
              ]),
            ]),
            _vm.hasDetail
              ? _c(
                  "div",
                  { staticClass: "config-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:merchant:update"],
                            expression: "['platform:merchant:update']",
                          },
                        ],
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.openEditDialog },
                      },
                      [_vm._v(" 编辑接收方id ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
            },
            [
              _vm.hasDetail
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "config-section" },
                      [
                        _c("div", { staticClass: "config-section__title" }, [
                          _vm._v("基础信息"),
                        ]),
                        _c(
                          "el-row",
                          { attrs: { gutter: 16 } },
                          [
                            _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "span",
                                  { staticClass: "info-item__label" },
                                  [_vm._v("商户ID")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "info-item__value" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.displayValue(_vm.detail.merId))
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "span",
                                  { staticClass: "info-item__label" },
                                  [_vm._v("商户名称")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "info-item__value" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayValue(
                                          _vm.displayMerchantName
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "span",
                                  { staticClass: "info-item__label" },
                                  [_vm._v("接收方id")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "info-item__value" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayValue(
                                          _vm.detail.jeequanMchNo
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "span",
                                  { staticClass: "info-item__label" },
                                  [_vm._v("接收方别名")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "info-item__value" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayValue(
                                          _vm.detail.receiverAlias
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "config-section" },
                      [
                        _c("div", { staticClass: "config-section__title" }, [
                          _vm._v("接收方状态"),
                        ]),
                        _c(
                          "el-row",
                          { attrs: { gutter: 16 } },
                          [
                            _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "span",
                                  { staticClass: "info-item__label" },
                                  [_vm._v("绑定状态")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "info-item__value" },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: _vm.statusTagType(
                                            _vm.detail.receiverBindStatus
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.statusText(
                                                _vm.detail.receiverBindStatus
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "span",
                                  { staticClass: "info-item__label" },
                                  [_vm._v("上游接收方ID")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "info-item__value" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayValue(
                                          _vm.detail.providerReceiverId
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c(
                                  "span",
                                  { staticClass: "info-item__label" },
                                  [_vm._v("最后同步时间")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "info-item__value" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatTime(_vm.detail.lastSyncTime)
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm.shouldShowReceiverFailReason(_vm.detail)
                              ? _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
                                  _c("div", { staticClass: "info-item" }, [
                                    _c(
                                      "span",
                                      { staticClass: "info-item__label" },
                                      [_vm._v("失败原因")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "info-item__value" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.displayValue(
                                              _vm.detail.receiverFailReason
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _c("div", { staticClass: "empty-state" }, [
                    _c("div", { staticClass: "empty-state__title" }, [
                      _vm._v(_vm._s(_vm.emptyTitle)),
                    ]),
                    _c("div", { staticClass: "empty-state__desc" }, [
                      _vm._v(_vm._s(_vm.emptyDescription)),
                    ]),
                  ]),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑接收方id",
            visible: _vm.editVisible,
            width: "520px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
            closed: _vm.resetEditForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editFormRef",
              attrs: {
                model: _vm.editForm,
                rules: _vm.editRules,
                "label-width": "120px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "商户ID" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.displayValue(_vm.detail.merId))),
                ]),
              ]),
              _c("el-form-item", { attrs: { label: "商户名称" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.displayValue(_vm.displayMerchantName))),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "接收方id", prop: "receiverId" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "64",
                      clearable: "",
                      placeholder: "请输入接收方id",
                    },
                    model: {
                      value: _vm.editForm.receiverId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editForm,
                          "receiverId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editForm.receiverId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.editVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.submitLoading,
                  },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }